// extracted by mini-css-extract-plugin
export default {"main":"style_main__uk3SP","header":"style_header__gRunG","notification":"style_notification__CgSJx","content":"style_content__ZjKVU","smallMenu":"style_smallMenu__+s7m9"};